const Validator = {
  email: {
    rules: [
      {
        test: /^[_a-z0-9-]+(\.[_a-z0-9-]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,})$/i,
        message: 'Please Enter Valid Email',
      },
    ],
    state: '',
  },
  password: {
    rules: [
      {
        test: (value) => {
          return value.length >= 8;
        },
        message: 'Password can not be < 8 characters',
      },
      {
        test: /^[a-z0-9A-Z_?!@#$&().,;:+*|£%\-\\ˆàéèìòù€]+$/,
        // test: /^[a-z0-9A-Z_]+$/,
        message: 'Enter Valid Password',
      },
    ],
    state: ''
  },
  privacy: {
    rules: [
      {
        test: (value) => {
          return value === true;
        },
        message: 'Select privacy checkbox',
      },
    ],
    state: false,
  },
  terms: {
    rules: [
      {
        test: (value) => {
          return value === true;
        },
        message: 'Select terms checkbox',
      },
    ],
    state: false,
  }
};

export default Validator;